export default "__VITE_ASSET__BsV5X_Hw__"